import React, { useRef, useState } from "react";
import { idempotencyKey } from "./helpers.mjs";
import { SolutionAgents } from "./ready-solution-agents.jsx";

export function CounterpartySolution({ api, solution, onCreated, canLaunch }) {
  const [inn, setInn] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const intent = useRef(null);
  const permitted = canLaunch ?? solution.permissions?.canLaunch ?? false;
  const ready = solution.readiness?.ready !== false;
  async function submit(event) {
    event.preventDefault();
    if (!permitted || !ready || busy) return;
    setBusy(true);
    setError("");
    const input = { inn: inn.trim(), purpose: "general" };
    const identity = JSON.stringify(input);
    if (!intent.current || intent.current.identity !== identity)
      intent.current = { identity, key: idempotencyKey() };
    try {
      const task = await api.request("/v1/tasks", {
        method: "POST",
        headers: { "Idempotency-Key": intent.current.key },
        body: { solutionId: solution.solutionId, input },
      });
      intent.current = null;
      onCreated(task);
    } catch (failure) {
      setError(
        failure.message || "Не удалось принять задание. Повторите отправку.",
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <article className="counterparty-pilot counterparty-solution">
      <h2>Получить справку</h2>
      {!ready && (
        <p className="inline-problem" role="status">
          {solution.readiness.message || "Решение пока не готово к запуску."}
        </p>
      )}
      {!permitted && (
        <p className="muted">
          Ваша роль позволяет просматривать результаты. Для запуска обратитесь к
          администратору организации.
        </p>
      )}
      {error && (
        <p className="inline-problem" role="alert">
          {error}
        </p>
      )}
      <form onSubmit={submit} className="counterparty-launch-form">
        <label>
          ИНН юридического лица
          <input
            required
            pattern="[0-9]{10}"
            inputMode="numeric"
            value={inn}
            disabled={busy || !permitted}
            onChange={(event) => setInn(event.target.value)}
          />
        </label>
        <button
          type="submit"
          className="button primary"
          disabled={busy || !permitted || !ready}
        >
          {busy ? "Принимаем задание…" : "Получить справку"}
        </button>
      </form>
      <div className="counterparty-launch-details">
        <details>
          <summary>О справке и расходах</summary>
          <div className="counterparty-launch-info">
            <p>
              {solution.agents?.some((agent) => agent.agentId === "counterparty-research-v2-3")
                ? "Исследователи соберут сведения о компании, затем Агент 3 объединит их в сводный черновик справки. Материалы каждого этапа сохраняются отдельно."
                : solution.agents?.some((agent) => agent.agentId === "counterparty-research-v2-2")
                  ? "Первое исследование дополнит Агент 2: он выполнит собственный поиск и сохранит новые сведения и расхождения."
                  : solution.agents?.length > 1 ? "Агенты 1 и 1.1 параллельно соберут отдельные досье о компании из открытых источников." : "Агент 1 соберёт подробное досье о компании из открытых источников."}
              {solution.agents?.some((agent) => agent.agentId === "counterparty-research-v2-4")
                ? " Затем Агент 4 проверит факты и сохранит отдельный файл замечаний только по явным ошибкам. Проверка не подтверждает все сведения справки."
                : " Это предварительные исследовательские материалы; фактчекинг ещё не выполнен."}
            </p>
            {solution.spendingLimit && (
              <p className="muted">
                Предел расходов на запуск: {solution.spendingLimit.amount}{" "}
                {solution.spendingLimit.currency}. Расходы учитываются в бюджете вашей
                организации.
              </p>
            )}
            <p className="muted">
              Задание появится в разделе «Задачи», готовая справка — в «Результатах».
              Доступно скачивание MD и JSON.
            </p>
          </div>
        </details>
        {solution.agents?.length > 0 && <details>
          <summary>Агенты решения</summary>
          <SolutionAgents solution={solution} showHeading={false}/>
        </details>}
      </div>
    </article>
  );
}
